import { gql } from '@apollo/client/core';

export const SensorDeviceGatewayFieldsFragment = gql`
  fragment SensorDeviceGatewayFieldsFragment on qx_Sensor {
    deviceConnectionStatus
    gatewayConnectionStatus
  }
`;

export const SensorSingleFragment = gql`
  fragment SensorSingleFragment on qx_Sensor {
    id
    defaultVideoSourceID
    videoSource {
      id
      name
      place {
        id
        name
      }
    }
    batteryLevel
    connectionStatus
    eBatteryLevel {
      comment
    }
    eDIOState {
      comment
    }
    eDeviceConnectionStatus {
      comment
    }
    eSensorType {
      comment
    }
    createdAt
    description
    deviceID
    device {
      id
      deviceAddress
      enabled
      connectionStatus
      pacsStatus
      pacsHWUpdate
      port
      tls
      model
      firmware
      serial
      deviceUsername
      devicePassword
      gateway {
        id
        name
        connectionStatus
        syncStatus
        type
      }
    }
    disabledByLicense
    enabled
    name
    placeID
    place {
      id
      name
      hierarchy {
        name
      }
      gateway {
        id
        name
        connectionStatus
        syncStatus
        type
      }
    }
    serial
    state
    type
    updatedAt
  }
`;


export const SensorSearchMiniFragment = gql`
  fragment SensorSearchMiniFragment on qx_Sensor {
    id
    name
    type
    place {
      id
      name
      hierarchy {
        name
      }
    }
  }
`;

export const LiveScrollerSensorResolveFragment = gql`
  fragment LiveScrollerSensorResolveFragment on qx_Sensor {
    id
    name
    type
  }
`;

export const GQL_SENSOR_SEARCH_MINI = gql`
  query GQL_SENSOR_SEARCH_MINI($where: qx_Sensor_bool_exp, $limit: Int, $offset: Int, $orderBy: [qx_Sensor_order_by!]) {
    sensors(limit: $limit, offset: $offset, where: $where, order_by: $orderBy) {
      ...SensorSearchMiniFragment
    }
    sensorAggregate(where: $where) {
      aggregate {
        count
      }
    }
  }
  ${SensorSearchMiniFragment}
`;

export const GQL_GET_SENSORS_BY_IDS = gql`
  query GQL_GET_SENSORS_BY_IDS($ids: [bigint!]!) {
    sensors(where: { id: { _in: $ids } }) {
      ...LiveScrollerSensorResolveFragment
    }
  }
  ${LiveScrollerSensorResolveFragment}
`;


export const GQL_GET_SENSOR_BY_ID = gql`
  query GQL_GET_SENSOR_BY_ID($id: bigint!) {
    sensor(id: $id) {
      ...SensorSingleFragment
    }
  }
  ${SensorSingleFragment}
`;

export const GQL_SUB_SENSOR_BY_ID = gql`
  subscription GQL_SUB_SENSOR_BY_ID($id: bigint!) {
    sensor(id: $id) {
      ...SensorSingleFragment
    }
  }
  ${SensorSingleFragment}
`;

export const SensorSearchFragment = gql`
  fragment SensorSearchFragment on qx_Sensor {
    id
    defaultVideoSourceID
    videoSource {
      id
      name
    }
    batteryLevel
    connectionStatus
    ...SensorDeviceGatewayFieldsFragment
    eBatteryLevel {
      comment
      value
    }
    eDIOState {
      comment
      value
    }
    eDeviceConnectionStatus {
      comment
      value
    }
    eSensorType {
      comment
      value
    }
    createdAt
    description
    deviceID
    device {
      id
      deviceAddress
      enabled
      connectionStatus
      pacsStatus
      pacsHWUpdate
      gateway {
        id
        name
        connectionStatus
        syncStatus
        type
      }
    }
    disabledByLicense
    enabled
    name
    placeID
    place {
      id
      name
      hierarchy {
        name
      }
      gateway {
        id
        name
        connectionStatus
        syncStatus
        type
      }
    }
    serial
    state
    type
    updatedAt
  }
  ${SensorDeviceGatewayFieldsFragment}
`;

export const GQL_SENSOR_SEARCH = gql`
  query GQL_SENSOR_SEARCH($where: qx_Sensor_bool_exp, $limit: Int, $offset: Int, $orderBy: [qx_Sensor_order_by!]) {
    sensors(limit: $limit, offset: $offset, where: $where, order_by: $orderBy) {
      ...SensorSearchFragment
    }
    sensorAggregate(where: $where) {
      aggregate {
        count
      }
    }
  }
  ${SensorSearchFragment}
`;

export const GQL_SENSOR_SEARCH_SUBSCRIPTION = gql`
  subscription GQL_SENSOR_SEARCH_SUBSCRIPTION(
    $where: qx_Sensor_bool_exp
    $limit: Int
    $offset: Int
    $orderBy: [qx_Sensor_order_by!]
  ) {
    sensors(limit: $limit, offset: $offset, where: $where, order_by: $orderBy) {
      ...SensorSearchFragment
    }
  }
  ${SensorSearchFragment}
`;
